import { useParams } from "react-router";
import { useRltWorkOrderShowQuery } from "@/services/backend/rlt/work-orders/api/work-order-api";
import { PositionsByArea } from "@/routes/processes/[processId]/rlt/work-orders/execution/[workOrderId]/treatment/_components/positions-by-area";
import { ErrValidationFailedContextProvider } from "@/shared/lib/errors/err-validation-failed-context";

export function WorkOrderExecutionTreatmentRoute() {
  const { workOrderId } = useParams();
  const { data } = useRltWorkOrderShowQuery({ id: workOrderId! });

  // The treatment is a document of its own inside the work order's page.
  // Its errors get a scope of their own.
  return (
    <ErrValidationFailedContextProvider>
      <PositionsByArea workOrder={data!} />
    </ErrValidationFailedContextProvider>
  );
}
